<div class="sticky-top mat-elevation-z6">
    <mat-toolbar class="trip-header-bar bds-toolbar-blue">
        <mat-toolbar-row>
            <span>
                <!-- <fa-icon [icon]="iconFlag" [fixedWidth]="true" size="lg"></fa-icon> -->
                Never Shipped
            </span>
            <span class="fill-remaining-space"></span>
            <span>
                <button mat-stroked-button (click)="removeFromFleet()">
                    <!-- <fa-icon [icon]="iconSave"></fa-icon> -->
                    Remove from Fleet<span class="nyi"></span>
                </button>
                <a mat-stroked-button [routerLink]="addTripRouterLink" target="_blank">
                    <!-- <fa-icon [icon]="iconSave"></fa-icon> -->
                    Add New Trip
                </a>
                <rt-jeopardized-shipment-reason-options
                    (resolve)="onResolve($event)"
                ></rt-jeopardized-shipment-reason-options>
            </span>
        </mat-toolbar-row>
    </mat-toolbar>
</div>
<div class="container">
    <mat-expansion-panel class="mt-3">
        <mat-expansion-panel-header>
            <mat-panel-title> Interface Validations<span class="nyi"></span> </mat-panel-title>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
            @if (tripError) {
            <!-- <rt-trip-error-details [tripError]="tripError" [highlightDirty]="true">
            </rt-trip-error-details> -->

            <div class="col-12 main-grid">
                <dx-data-grid
                    bds-grid
                    [bdsAllowGridModeToggle]="allowModeToggle"
                    [dataSource]="gridSource"
                    height="300px"
                    [allowColumnReordering]="true"
                    [allowColumnResizing]="true"
                    [columnAutoWidth]="true"
                    [showBorders]="true"
                >
                    <!-- [(selectedRowKeys)]="selectedRowKeys" -->
                    <!-- (onSelectionChanged)="onSelectionChanged($event)" -->
                    <dxo-remote-operations [groupPaging]="true"></dxo-remote-operations>
                    <dxo-header-filter [visible]="true" [allowSearch]="true"></dxo-header-filter>
                    <dxo-filter-row [visible]="true" applyFilter="onClick"></dxo-filter-row>
                    <dxo-group-panel [visible]="false"></dxo-group-panel>
                    <dxo-grouping [autoExpandAll]="false"></dxo-grouping>
                    <dxo-column-chooser [enabled]="false" mode="dragAndDrop"></dxo-column-chooser>
                    <dxo-paging [pageSize]="20"></dxo-paging>
                    <dxo-selection
                        [mode]="gridSelectionMode"
                        [allowSelectAll]="false"
                        showCheckBoxesMode="always"
                    ></dxo-selection>
                    <dxo-export
                        [enabled]="false"
                        fileName="RAILTRAC Interface Validation Data"
                    ></dxo-export>
                    <dxo-scrolling
                        mode="virtual"
                        rowRenderingMode="virtual"
                        columnRenderingMode="virtual"
                    ></dxo-scrolling>
                    <dxo-load-panel [enabled]="true"></dxo-load-panel>

                    <dxi-column dataField="carInit" caption="Car Init"></dxi-column>
                    <dxi-column dataField="carNo" caption="Car Number"></dxi-column>
                    <dxi-column
                        dataField="shipDateTime"
                        caption="Ship Date Time"
                        dataType="datetime"
                    ></dxi-column>

                    <dxi-column dataField="fleetId" caption="Fleet ID"></dxi-column>
                    <dxi-column dataField="businessGroup" caption="Business Group"></dxi-column>
                    <dxi-column dataField="freeRunner" caption="Free Runner"></dxi-column>
                    <dxi-column
                        dataField="errorDescription"
                        caption="Error Description"
                    ></dxi-column>
                    <dxi-column dataField="shipperNo" caption="Shipper Number"></dxi-column>
                    <dxi-column dataField="origCity" caption="Origin City"></dxi-column>
                    <dxi-column dataField="origState" caption="Origin State"></dxi-column>

                    <dxi-column dataField="destCity" caption="Destination City"></dxi-column>
                    <dxi-column dataField="destState" caption="Destination State"></dxi-column>
                    <dxi-column dataField="custNo" caption="Customer Number"></dxi-column>
                    <dxi-column dataField="custName" caption="Customer Name "></dxi-column>
                    <dxi-column dataField="routCode" caption="Route Code"></dxi-column>
                    <dxi-column dataField="importSource" caption="Import Source"></dxi-column>
                    <dxi-column dataField="commName" caption="Commodity Name"></dxi-column>
                    <dxi-column dataField="commCode" caption="Commodity Code"></dxi-column>
                </dx-data-grid>
            </div>
            } @else {
            <div class="mt-3 mb-3">No Interface Validations found for this shipment.</div>
            }
        </ng-template>
    </mat-expansion-panel>
    <mat-expansion-panel class="mt-3">
        <mat-expansion-panel-header>
            <mat-panel-title> Fleet Assignment<span class="nyi"></span> </mat-panel-title>
        </mat-expansion-panel-header>
        <ng-template matExpansionPanelContent>
            Fleet Assignment appear here<span class="nyi"></span>
        </ng-template>
    </mat-expansion-panel>
    <div class="container mt-3 mb-3">
        <rt-jeopardized-shipment-details [shipment]="shipment"></rt-jeopardized-shipment-details>
    </div>
</div>
